import React from "react";
import { Select } from "antd";

const { Option } = Select;
interface OptionProps {
  id: string;
  name: string;
}
type DropdownProps = {
  label?: string;
  options: { label: string; value: string | number }[];
  onChange: (value: string | number |OptionProps[]| (string | number)[]) => void;
  value?: string | number | null | undefined | (string | number)[];
  placeholder?: string;
  className?: string;
  isMultiselect?: boolean;
};

const CustomDropdown: React.FC<DropdownProps> = ({
  label,
  options,
  onChange,
  value,
  placeholder = "Select an option",
  className = "",isMultiselect=false
}) => {
  return (
    <div className={`flex flex-col  ${className}`}>
      {label && <label className="common-label pb-[6px]">{label}</label>}
      <Select
        showSearch
        value={isMultiselect ? (Array.isArray(value) ? (value as (string | number)[]) : []) : (Array.isArray(value) ? undefined : value)}
        mode={isMultiselect ? "multiple" : undefined}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full rounded-md border-gray-300  focus:border-blue-500 focus:ring focus:ring-blue-200 h-[40px]"
        optionFilterProp="label" // Filters based on label
        filterOption={(input, option) =>
          option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
        }
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value} label={option.label}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default CustomDropdown;
